import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const MobileHeader = styled("div", {shouldForwardProp: prop => prop !== "sticky"})<{sticky: boolean}>`
    background: #ffffff;
    border-bottom: ${props => props.theme.colours.utilities.dividerDark};
    border-top: ${props => props.theme.colours.utilities.dividerDark};
    border-bottom-color: ${props => props.theme.colours.components.buttonGroup.default.borderBottomColor};
    border-top-color: ${props => props.theme.colours.components.buttonGroup.default.borderTopColor};
    border-radius: 0;
    display: flex;
    position: fixed;
    width: 100%;
    z-index: 1;

    & > div {
        border-left: ${props => props.theme.colours.utilities.dividerDark};
        border-color: ${props => props.theme.colours.other.divider};
    }
    & > div:first-of-type {
        border-left: none;
    }
    @media (min-width: ${breakpoints.values.md}px) {
        margin-top: 0.05rem;
    }
    @media (max-width: ${breakpoints.values.md - 1}px) {
        top: ${({sticky}) => (sticky ? `var(--next-header-scroll-height, 2.75rem)` : "")};
    }
`
